var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.72,
    height: 16.72,
    viewBox: "0 0 16.72 16.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(16.72 16.72) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 8.36,
    cy: 8.36,
    r: 8.36,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    "data-name": "Icon ionic-ios-arrow-round-forward",
    d: "M15.62,11.372a.421.421,0,0,0,0,.6l2.047,2H11.309a.427.427,0,1,0,0,.853h6.35l-2.047,2a.424.424,0,0,0,0,.6.444.444,0,0,0,.616,0L19.006,14.7h0a.478.478,0,0,0,.091-.135.4.4,0,0,0,.034-.164.422.422,0,0,0-.125-.3l-2.774-2.723A.437.437,0,0,0,15.62,11.372Z",
    transform: "translate(-6.956 -5.873)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0a16ff60abce6c9c26f01892ee90a0a8.svg";
export { ForwardRef as ReactComponent };